define("shared/components/shared/ui/social-profile-switcher/list", ["exports", "@ember/component", "@ember/service", "@ember/utils", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _utils, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--dropWrapper--md qa--profileSwitcher_dropdown" ...attributes>
    <div class="o--dropBody">
      {{#if this.hasOtherProfiles}}
        <ul class="o--dropBody__list o--dropBody--scroll o--page__switcherDrop">
          {{#each this.displayableSwitchableProfiles as |socialProfile|}}
            <Shared::Ui::SocialProfileSwitcher::Item @onChange={{@onChange}} @socialProfile={{socialProfile}} />
          {{/each}}
          {{! Note: If in analytics & has more than 1 available profile }}
          {{#if this.hasUpgradableProfiles}}
            <li class="o--dropBody__item u--p__xs">
              <span class="u--text--sm u--text--light">
                {{this.upgradeText}}
              </span>
            </li>
            {{#each @upgradableProfiles as |socialProfile|}}
              <Shared::Ui::SocialProfileSwitcher::Item
                @onChange={{unless @areUpgradableProfilesUnswitchable @onChange}}
                @socialProfile={{socialProfile}}
                class={{if @areUpgradableProfilesUnswitchable "u--mute"}}
              />
            {{/each}}
          {{/if}}
          {{#if this.hasLinkinbioPages}}
            <li class="o--dropBody__item u--p__xs">
              <span class="u--text--sm u--text--light">
                {{t "shared_phrases.linkinbio_pages"}}
              </span>
            </li>
            {{#each this.displayableSwitchablePages as |linkinbioPage|}}
              <Shared::Ui::SocialProfileSwitcher::Linkinbio::Item
                @linkinbioPage={{linkinbioPage}}
                @onChange={{@onChange}}
                @socialProfile={{linkinbioPage.instagramProfile}}
              />
            {{/each}}
          {{/if}}
          {{! If has profiles }}
          {{#if this.hasUnswitchableProfiles}}
            <li class="o--dropBody__item u--p__xs">
              <span class="u--text--sm u--text--light">
                {{t "shared_phrases.not_available"}}
              </span>
            </li>
            {{#each @unswitchableProfiles as |socialProfile|}}
              <Shared::Ui::SocialProfileSwitcher::Item @socialProfile={{socialProfile}} class="u--mute" />
            {{/each}}
          {{/if}}
        </ul>
      {{else}}
        <div class="o--blank u--p__tb__lg">
          <p class="o--blank__title">
            {{t "shared_phrases.no_other_profiles"}}
          </p>
        </div>
      {{/if}}
    </div>
  </div>
  */
  {
    "id": "Y0Cy6FRA",
    "block": "[[[11,0],[24,0,\"o--dropWrapper--md qa--profileSwitcher_dropdown\"],[17,1],[12],[1,\"\\n  \"],[10,0],[14,0,\"o--dropBody\"],[12],[1,\"\\n\"],[41,[30,0,[\"hasOtherProfiles\"]],[[[1,\"      \"],[10,\"ul\"],[14,0,\"o--dropBody__list o--dropBody--scroll o--page__switcherDrop\"],[12],[1,\"\\n\"],[42,[28,[37,2],[[28,[37,2],[[30,0,[\"displayableSwitchableProfiles\"]]],null]],null],null,[[[1,\"          \"],[8,[39,3],null,[[\"@onChange\",\"@socialProfile\"],[[30,3],[30,2]]],null],[1,\"\\n\"]],[2]],null],[41,[30,0,[\"hasUpgradableProfiles\"]],[[[1,\"          \"],[10,\"li\"],[14,0,\"o--dropBody__item u--p__xs\"],[12],[1,\"\\n            \"],[10,1],[14,0,\"u--text--sm u--text--light\"],[12],[1,\"\\n              \"],[1,[30,0,[\"upgradeText\"]]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"],[42,[28,[37,2],[[28,[37,2],[[30,4]],null]],null],null,[[[1,\"            \"],[8,[39,3],[[16,0,[52,[30,6],\"u--mute\"]]],[[\"@onChange\",\"@socialProfile\"],[[52,[51,[30,6]],[30,3]],[30,5]]],null],[1,\"\\n\"]],[5]],null]],[]],null],[41,[30,0,[\"hasLinkinbioPages\"]],[[[1,\"          \"],[10,\"li\"],[14,0,\"o--dropBody__item u--p__xs\"],[12],[1,\"\\n            \"],[10,1],[14,0,\"u--text--sm u--text--light\"],[12],[1,\"\\n              \"],[1,[28,[35,5],[\"shared_phrases.linkinbio_pages\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"],[42,[28,[37,2],[[28,[37,2],[[30,0,[\"displayableSwitchablePages\"]]],null]],null],null,[[[1,\"            \"],[8,[39,6],null,[[\"@linkinbioPage\",\"@onChange\",\"@socialProfile\"],[[30,7],[30,3],[30,7,[\"instagramProfile\"]]]],null],[1,\"\\n\"]],[7]],null]],[]],null],[41,[30,0,[\"hasUnswitchableProfiles\"]],[[[1,\"          \"],[10,\"li\"],[14,0,\"o--dropBody__item u--p__xs\"],[12],[1,\"\\n            \"],[10,1],[14,0,\"u--text--sm u--text--light\"],[12],[1,\"\\n              \"],[1,[28,[35,5],[\"shared_phrases.not_available\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"],[42,[28,[37,2],[[28,[37,2],[[30,8]],null]],null],null,[[[1,\"            \"],[8,[39,3],[[24,0,\"u--mute\"]],[[\"@socialProfile\"],[[30,9]]],null],[1,\"\\n\"]],[9]],null]],[]],null],[1,\"      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,0],[14,0,\"o--blank u--p__tb__lg\"],[12],[1,\"\\n        \"],[10,2],[14,0,\"o--blank__title\"],[12],[1,\"\\n          \"],[1,[28,[35,5],[\"shared_phrases.no_other_profiles\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"&attrs\",\"socialProfile\",\"@onChange\",\"@upgradableProfiles\",\"socialProfile\",\"@areUpgradableProfilesUnswitchable\",\"linkinbioPage\",\"@unswitchableProfiles\",\"socialProfile\"],false,[\"if\",\"each\",\"-track-array\",\"shared/ui/social-profile-switcher/item\",\"unless\",\"t\",\"shared/ui/social-profile-switcher/linkinbio/item\"]]",
    "moduleName": "shared/components/shared/ui/social-profile-switcher/list.hbs",
    "isStrictMode": false
  });
  let ListComponent = _exports.default = (_class = class ListComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "intl", _descriptor, this);
    }
    get hasUnswitchableProfiles() {
      return this.args.unswitchableProfiles?.length > 0;
    }
    get hasUpgradableProfiles() {
      return this.args.upgradableProfiles?.length > 0;
    }
    get hasSwitchableProfiles() {
      return this.displayableSwitchableProfiles?.length > 0;
    }
    get hasLinkinbioPages() {
      return this.displayableSwitchablePages?.length > 0;
    }
    get hasOtherProfiles() {
      return this.hasUnswitchableProfiles || this.hasSwitchableProfiles || this.hasUpgradableProfiles || this.hasLinkinbioPages;
    }
    get displayableSwitchableProfiles() {
      if ((0, _utils.isPresent)(this.args.selectedLinkinbioPage)) {
        return this.args.switchableProfiles;
      }
      return this.args.switchableProfiles?.filter(socialProfile => socialProfile.id !== this.args.selectedProfile?.id);
    }
    get displayableSwitchablePages() {
      return this.args.linkinbioPages?.filter(page => {
        const isExisting = (0, _utils.isPresent)(page.get('id')) && (0, _utils.isPresent)(page.get('urlName'));
        const isNotCurrentPage = page.get('id') !== this.args.selectedLinkinbioPage?.get('id');
        return isExisting && isNotCurrentPage;
      });
    }
    get upgradeText() {
      return (0, _utils.isPresent)(this.args.upgradeText) ? this.args.upgradeText : this.intl.t('shared_phrases.available_for_paid_plans');
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ListComponent);
});